import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const joinWaitlist = async ({ email, source, signalKey }) => {
  const { data } = await axios.post(`${API}/waitlist`, {
    email,
    source: source || "site",
    signal_key: signalKey || ""
  });
  return data;
};

export const fetchWaitlistCount = async () => {
  const { data } = await axios.get(`${API}/waitlist/count`);
  return data.count;
};

export const fetchAdminWaitlist = async (token) => {
  const { data } = await axios.get(`${API}/admin/waitlist`, {
    params: { token }
  });
  return data;
};

export const adminCsvUrl = (token) =>
  `${API}/admin/waitlist.csv?token=${encodeURIComponent(token)}`;

export const deleteAdminEntry = async (token, id) => {
  const { data } = await axios.delete(`${API}/admin/waitlist/${id}`, {
    params: { token }
  });
  return data;
};

/* -------------------------------- analytics ------------------------------- */

export const recordVisit = async ({ path, referrer }) => {
  const { data } = await axios.post(`${API}/visit`, {
    path: path || "/",
    referrer: referrer || ""
  });
  return data;
};

export const recordReadProgress = async ({ depth, prologueDone, finished }) => {
  const { data } = await axios.post(`${API}/read-progress`, {
    depth: Math.round(depth || 0),
    prologue_done: Boolean(prologueDone),
    finished: Boolean(finished)
  });
  return data;
};

export const fetchAdminStats = async (token, days = 14) => {
  const { data } = await axios.get(`${API}/admin/stats`, {
    params: { token, days }
  });
  return data;
};

export const resetAdminStats = async (token) => {
  const { data } = await axios.delete(`${API}/admin/stats`, {
    params: { token }
  });
  return data;
};

/* ------------------------------ requisitions ------------------------------ */

export const submitRequisition = async (payload) => {
  const { data } = await axios.post(`${API}/requisition`, payload);
  return data;
};

export const fetchAdminRequisitions = async (token) => {
  const { data } = await axios.get(`${API}/admin/requisitions`, {
    params: { token }
  });
  return data;
};

export const adminRequisitionsCsvUrl = (token) =>
  `${API}/admin/requisitions.csv?token=${encodeURIComponent(token)}`;

export const deleteAdminRequisition = async (token, id) => {
  const { data } = await axios.delete(`${API}/admin/requisitions/${id}`, {
    params: { token }
  });
  return data;
};

/* ------------------------------- dispatches ------------------------------- */

export const fetchAdminDispatches = async (token) => {
  const { data } = await axios.get(`${API}/admin/dispatch`, {
    params: { token }
  });
  return data;
};

export const sendAdminDispatch = async (token, { campaign, testTo, confirm }) => {
  const { data } = await axios.post(
    `${API}/admin/dispatch`,
    {
      campaign,
      test_to: testTo || null,
      confirm: Boolean(confirm)
    },
    { params: { token } }
  );
  return data;
};
